import { DepartmentDto } from './DepartmentDto'

export interface UserResponse {
  id: string
  email: string
  name: string
  firstName: string
  lastName: string
  dateFormatType: { id: number; name: string } | null
  kind: { id: number; name: string } | null
  departments: DepartmentDto[] | null
  status: {
    id: number
    name: string
  } | null
  isAutoAssignmentPaused: boolean
  autoAssignmentPausedStart: null | string
  autoAssignmentPausedUntil: null | string
  roles: string[]
  teams: string[]
  lastSuccessfulLogin: string | null
  failedLoginsCount: number
  personalTeam: { id: number; name: string }
  selected?: boolean
  eligibleToClientAutoAssignments: ClientAutoAssignmentDto[]
  userTeams: ClientAutoAssignmentDto[]
  isLocal: boolean
}

export interface ClientAutoAssignmentDto {
  team: { id: string; name: string }
  language: { id: string; name: string } | null
  eligible: boolean
  visibility: boolean
}

export interface SimpleUserResponse {
  id: string
  name: string
  status?: {
    id: number
    name: string
  }
}

export enum UserStatus {
  Pending = 0,
  Confirmed = 1,
  Locked = 2,
}

export const isUserStatusLocked = (userStatus?: number | null): boolean => {
  return userStatus === UserStatus.Locked
}

export enum UserFilterKey {
  departments = 'Departments',
  status = 'Status',
  kind = 'Kind',
}
